import styled from "styled-components";
import {useRecoilValue} from "recoil";
import userState from "../utils/user-state";
import User from "../models/user";
import {useHistory, useLocation} from "react-router-dom";
import {createRef, useContext, useEffect, useState} from "react";
import FirebaseContext from "../utils/firebase-context";
import { AdminPanelSettingsRounded, ArrowDropDownRounded, InfoRounded, LogoutRounded } from "@mui/icons-material";

const TopBarStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  border-bottom: 1px solid #f0f0f0;
  z-index: 900;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  background: white;
`;
const Title = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  color: #0398fc;
  cursor: pointer;
`;

const UserBlock = styled.div`
  padding: .75rem 1rem;
  cursor: pointer;
  border-radius: 12px;
  display: grid;
  grid-auto-flow: column;
  gap: .75rem;
  transition: .1s;
  font-size: 1.2rem;
  font-weight: 600;
  &:hover {
    background: #EEEEEE;
  }
`;

const Menu = styled.div`
  position: fixed;
  z-index: 900;
  right: .5rem;
  top: 68px;
  width: 300px;
  padding: .5rem;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  background: white;
`;

const MenuElement = styled.div`
  padding: .75rem 1rem;
  border-radius: 12px;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: #f5f5f5;
  }
`;

export default function TopBar() {
    const user = useRecoilValue(userState);
    const history = useHistory();
    const location = useLocation();
    const ref = createRef<HTMLDivElement>();
    const firebase = useContext(FirebaseContext);
    const [showMenu, setShowMenu] = useState(false);
    const [requestCount, setRequestCount] = useState(0);

    const userComponent = (u: User) => {
        return <UserBlock onClick={() => setShowMenu(true)}>
            <div>
                {u.firstName + " " + u.lastName} {u.admin && requestCount > 0 && "(" + requestCount + ")"}
            </div>
            <div>
                <ArrowDropDownRounded />
            </div>
        </UserBlock>
    }

    const menuAction =(action: () => void) => () => {
        action();
        setShowMenu(false);
    };

    useEffect(() => {
        const listener = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as HTMLElement)) {
                setShowMenu(false);
            }
        };

        document.addEventListener("click", listener);

        return () => document.removeEventListener("click", listener);
    }, [ref]);

    useEffect(() => {
        return firebase.getRequestCollection().onSnapshot(snapshot => setRequestCount(snapshot.size));
    }, [firebase, setRequestCount]);

    return <>
        <TopBarStyle>
            <Title onClick={() => history.push("/")}>BitterLiebe {location.pathname === "/admin" && "- Admin"}</Title>
            {user && userComponent(user)}
        </TopBarStyle>
        {showMenu && <Menu ref={ref}>

            {user && location.pathname !== "/admin" && user.admin && <MenuElement onClick={menuAction(() => history.push("/admin"))}>
                <div>
                    Admin {requestCount > 0 && "(" + requestCount + " Anfrage)"}
                </div>
                <div>
                    <AdminPanelSettingsRounded />
                </div>
            </MenuElement>}

            <MenuElement>
                <div>
                    Help Center
                </div>
                <div>
                    <InfoRounded />
                </div>
            </MenuElement>

            <MenuElement onClick={menuAction(async () => await firebase.signOut())}>
                <div>
                    Ausloggen
                </div>
                <div>
                    <LogoutRounded />
                </div>
            </MenuElement>
        </Menu>}
    </>
}